import uplLogo from '../img/upl.png';
import cupOfUkraineLogo from '../img/cupOfUkraineLogo.png';
import firstLeagueLogo from '../img/firstLeague.png';
import secondLeagueLogo from '../img/secondLeague.png';
import ukraineLogo from '../img/ukraine.png';
import eplLogo from '../img/eplLogo.png';
import laLigaLogo from '../img/laLigaLogo.png';
import serieALogo from '../img/SeriaALogo.png';
import bundesligaLogo from '../img/bundesligaLogo.png';
import ligue1Logo from '../img/ligue1Logo.png';
import europeNewsLogo from '../img/europeNewsLogo.png';
import championsLeagueLogo from '../img/championsLeagueLogo.png';
import europaLeagueLogo from '../img/europaLeagueLogo.png';
import conferenceLeagueLogo from '../img/conferenceLeagueLogo.png';
import boxingImage from '../img/boxingImage.png';
import biathlonImage from '../img/newsBiathlonImage.png';
import tennisImage from '../img/tennisImage.png';
import mmaImage from '../img/mmaImage.png';
import futsalImage from '../img/futsalImage.png';
import shakhtarLogo from '../img/shakhtarLogo.png';
import dynamoLogo from '../img/dynamoLogo.png';
import polissyaLogo from '../img/polissyaLogo.png';
import yuksaLogo from '../img/yuksaLogo.png';
import bukovynaLogo from '../img/bukovynaLogo.png';
import metalist1925Logo from '../img/metalist1925Logo.png';
import lNZLogo from '../img/lnzLogo.png';
import kolosLogo from '../img/kolosLogo.png';
import kryvbasLogo from '../img/kryvbasLogo.png';
import zoryaLogo from '../img/zoryaLogo.png';
import karpatyLogo from '../img/karpatyLogo.png';
import epitsenterLogo from '../img/epitsenterLogo.png';
import veresLogo from '../img/veresLogo.png';
import obolonLogo from '../img/obolonLogo.png';
import kudrivkaLogo from '../img/kudrivkaLogo.png';
import chornomoretsLogo from '../img/chornomoretsLogo.jpg';
import lberigLogo from '../img/lberigLogo.png';
import oleksandriyaLogo from '../img/oleksandriyaLogo.png';
import poltavaLogo from '../img/poltavaLogo.png';
import agrobiznesLogo from '../img/agrobiznesLogo.png';
import ingulecLogo from '../img/ingulecLogo.png';
import prykarpattiaLogo from '../img/prykarpattiaLogo.png';
import metalistLogo from '../img/metalistLogo.png';
import probiyLogo from '../img/probiyLogo.jpeg';
import fenixMariupolLogo from '../img/fenixMariupolLogo.png';
import viktoriyaLogo from '../img/viktoriyaLogo.png';
import nyvaLogo from '../img/nyvaLogo.png';
import chernihivLogo from '../img/chernihivLogo.png';
import kulykivBilkaLogo from '../img/kulykivBilkaLogo.png';
import lokomotivLogo from '../img/lokomotivLogo.png';
import rukhLogo from '../img/rukhLogo.png';
import podillyaLogo from '../img/podillyaLogo.png';
import metalurhLogo from '../img/metalurhLogo.png';
import dinazLogo from '../img/dinazLogo.png';
import skalaLogo from '../img/skala1911Logo.jpg';
import nyvaVinnytsiaLogo from '../img/nyvaVinnytsiaLogo.png';
import atletLogo from '../img/atletLogo.png';
import vilkhivtsiLogo from '../img/vilkhivtsiLogo.png';
import rebelLogo from '../img/rebelLogo.png';
import trostyanetsLogo from '../img/trostyanetsLogo.png';
import penuelLogo from '../img/penuelLogo.png';
import bratslavLogo from '../img/bratslavLogo.png';
import dnisterLogo from '../img/dnisterZalishchykyLogo.png';
import avangardLogo from '../img/avangardLozovaLogo.png';
import carbonLogo from '../img/carbonCherkasyLogo.png';
import vorsklaLogo from '../img/vorsklaLogo.png';
import minaiLogo from '../img/minaiLogo.png';
import hirnykLogo from '../img/hirnykLogo.png';
import realPharmaLogo from '../img/realPharmaLogo.png';
import lisneLogo from '../img/lisneLogo.png';
import uzhorodLogo from '../img/uzhorodLogo.png';
import kreminLogo from '../img/kreminLogo.png';

const normalizeCategoryKey = (value) => String(value || '')
  .trim()
  .toLocaleLowerCase('uk-UA')
  .replace(/[’ʼ`]/g, "'")
  .replace(/\s+/g, ' ');

const iconEntries = [
  [['УПЛ', 'Українська Премєр Ліга', 'Українська Прем’єр-ліга'], uplLogo, 'УПЛ'],
  [['Кубок України'], cupOfUkraineLogo, 'Кубок України'],
  [['Перша Ліга'], firstLeagueLogo, 'Перша ліга'],
  [['Друга Ліга'], secondLeagueLogo, 'Друга ліга'],
  [['Збірна України'], ukraineLogo, 'Збірна України'],
  [['Англійська Премʼєр-ліга', 'Англійська Прем’єр-ліга', 'Premier League'], eplLogo, 'Англійська Прем’єр-ліга'],
  [['Іспанська Ла Ліга', 'La Liga'], laLigaLogo, 'Іспанська Ла Ліга'],
  [['Італійська Серія А', 'Serie A'], serieALogo, 'Італійська Серія А'],
  [['Німецька Бундесліга', 'Bundesliga'], bundesligaLogo, 'Німецька Бундесліга'],
  [['Французька Ліга 1', 'Ligue 1'], ligue1Logo, 'Французька Ліга 1'],
  [['Європейські новини'], europeNewsLogo, 'Європейські новини'],
  [['Ліга Чемпіонів', 'Ліга чемпіонів', 'Champions League'], championsLeagueLogo, 'Ліга чемпіонів'],
  [['Ліга Європи', 'Europa League'], europaLeagueLogo, 'Ліга Європи'],
  [['Ліга Конференцій', 'Ліга конференцій', 'Conference League'], conferenceLeagueLogo, 'Ліга конференцій'],
  [['Бокс'], boxingImage, 'Бокс'],
  [['Біатлон', 'Новини біатлону'], biathlonImage, 'Біатлон'],
  [['Теніс'], tennisImage, 'Теніс'],
  [['MMA'], mmaImage, 'MMA'],
  [['Футзал'], futsalImage, 'Футзал'],
  [['Шахтар'], shakhtarLogo, 'Шахтар'],
  [['Динамо Київ'], dynamoLogo, 'Динамо Київ'],
  [['Полісся'], polissyaLogo, 'Полісся'],
  [['ЮКСА'], yuksaLogo, 'ЮКСА'],
  [['Буковина'], bukovynaLogo, 'Буковина'],
  [['ФК Харків', 'Металіст 1925'], metalist1925Logo, 'ФК Харків'],
  [['ЛНЗ'], lNZLogo, 'ЛНЗ'],
  [['Колос'], kolosLogo, 'Колос'],
  [['Кривбас'], kryvbasLogo, 'Кривбас'],
  [['Зоря'], zoryaLogo, 'Зоря'],
  [['Карпати'], karpatyLogo, 'Карпати'],
  [['Епіцентр'], epitsenterLogo, 'Епіцентр'],
  [['Верес'], veresLogo, 'Верес'],
  [['Оболонь'], obolonLogo, 'Оболонь'],
  [['Кудрівка'], kudrivkaLogo, 'Кудрівка'],
  [['Чорноморець'], chornomoretsLogo, 'Чорноморець'],
  [['Лівий Берег'], lberigLogo, 'Лівий Берег'],
  [['Олександрія'], oleksandriyaLogo, 'Олександрія'],
  [['Полтава'], poltavaLogo, 'Полтава'],
  [['Агробізнес'], agrobiznesLogo, 'Агробізнес'],
  [['Інгулець'], ingulecLogo, 'Інгулець'],
  [['Прикарпаття'], prykarpattiaLogo, 'Прикарпаття'],
  [['Металіст'], metalistLogo, 'Металіст'],
  [['Пробій'], probiyLogo, 'Пробій'],
  [['Фенікс-Маріуполь'], fenixMariupolLogo, 'Фенікс-Маріуполь'],
  [['Вікторія'], viktoriyaLogo, 'Вікторія'],
  [['Нива'], nyvaLogo, 'Нива'],
  [['Чернігів'], chernihivLogo, 'Чернігів'],
  [['Куликів-Білка'], kulykivBilkaLogo, 'Куликів-Білка'],
  [['Локомотив'], lokomotivLogo, 'Локомотив'],
  [['Рух'], rukhLogo, 'Рух'],
  [['Поділля'], podillyaLogo, 'Поділля'],
  [['Металург'], metalurhLogo, 'Металург'],
  [['Діназ'], dinazLogo, 'Діназ'],
  [['Скала 1911'], skalaLogo, 'Скала 1911'],
  [['Нива Вінниця'], nyvaVinnytsiaLogo, 'Нива Вінниця'],
  [['Атлет'], atletLogo, 'Атлет'],
  [['Вільхівці'], vilkhivtsiLogo, 'Вільхівці'],
  [['Ребел'], rebelLogo, 'Ребел'],
  [['Тростянець'], trostyanetsLogo, 'Тростянець'],
  [['Пенуел'], penuelLogo, 'Пенуел'],
  [['Брацлав'], bratslavLogo, 'Брацлав'],
  [['Дністер'], dnisterLogo, 'Дністер'],
  [['Авангард'], avangardLogo, 'Авангард'],
  [['Карбон'], carbonLogo, 'Карбон'],
  [['Ворскла'], vorsklaLogo, 'Ворскла'],
  [['Минай'], minaiLogo, 'Минай'],
  [['Гірник-Спорт'], hirnykLogo, 'Гірник-Спорт'],
  [['Реал Фарма'], realPharmaLogo, 'Реал Фарма'],
  [['Лісне'], lisneLogo, 'Лісне'],
  [['ФК Ужгород'], uzhorodLogo, 'ФК Ужгород'],
  [['Кремінь'], kreminLogo, 'Кремінь'],
];

const categoryIconMap = new Map();

iconEntries.forEach(([aliases, src, label]) => {
  aliases.forEach((alias) => {
    categoryIconMap.set(normalizeCategoryKey(alias), { src, label });
  });
});

export const getNewsPrimarySection = (news = {}) => {
  const firstSection = Array.isArray(news.sections)
    ? news.sections[0]
    : null;

  return String(firstSection || news.section || news.category || '').trim();
};

export const resolveCategoryIcon = (value) => {
  return categoryIconMap.get(normalizeCategoryKey(value)) || null;
};

export const resolveNewsCategoryIcon = (news = {}) => {
  const primarySection = getNewsPrimarySection(news);
  const hasArrayPrimary = Array.isArray(news.sections)
    && Boolean(news.sections[0]);
  const fallbackCandidates = hasArrayPrimary
    ? [primarySection]
    : [news.section, news.category].filter(Boolean);

  for (const candidate of fallbackCandidates) {
    const icon = resolveCategoryIcon(candidate);

    if (icon) {
      return {
        ...icon,
        primarySection,
        resolvedSection: String(candidate).trim(),
      };
    }
  }

  return {
    icon: null,
    label: primarySection || 'Категорія',
    primarySection,
    resolvedSection: primarySection,
  };
};
